export default __webpack_public_path__ + "static/media/AAP_Logo_NEW_1080.8bc077ea.jpg";